import React from "react";

const FlecheDownFaq = () =>{
    return(
        <>
           <svg className="FlecheDownFaq" width="51" height="52" viewBox="0 0 51 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <circle style={{cursor:'pointer'}} cx="25.6546" cy="26.2516" r="25.3309" fill="#4A3AFF"/>
                                                                            <path d="M17.3979 23.142L25.6545 31.3612L33.9111 23.142" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                            </svg>
        </>
    )
}

export default FlecheDownFaq